import { Modal } from '../../templates/Modal';
import FreemiumLockContent from './LockContent';

interface IFreemiumLockModal {
  isOpen: boolean;
  onClose: () => void;
}

export default function FreemiumLockModal({
  isOpen,
  onClose,
}: IFreemiumLockModal) {
  return (
    <Modal
      position='center'
      size='sm'
      isOpen={isOpen}
      onClose={onClose}
      className='md:w-2/5 xs:w-full'
    >
      <FreemiumLockContent />
    </Modal>
  );
}
